import { StyleSheet } from 'react-native';

import type { AppTheme } from '@/styles/theme';

export type OrganizationEditStyleSheet = ReturnType<
  typeof makeOrganizationEditFormStyles
>;

export const makeOrganizationEditFormStyles = (theme: AppTheme) =>
  StyleSheet.create({
    header: { alignItems: 'center', gap: 8 },
    centered: { textAlign: 'center' },
    avatar: {
      paddingHorizontal: 48,
      paddingVertical: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },
    sectionTitle: { color: theme.colors.onSurface, marginTop: 8 },
    section: { gap: 8 },
    // Prevent the multiline input's flex:1 wrapper from collapsing against the
    // detail-image grid that follows it.
    multilineInput: { marginBottom: 16 },
    // Match the screen background instead of the default (darker) outlined
    // input fill.
    descriptionInput: { backgroundColor: theme.colors.surfaceContainerLow },
    actions: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginTop: 8
    },
    actionButton: { flex: 1 },
    deleteMenuItemTitle: { color: theme.colors.error, fontSize: 14 }
  });
